import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";
import { deleteProdCodeType } from "../../../../../actions/Utilities/ProducerCodeType/index";

const useDeleteProdCodeType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteProdCodeType(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetProducerCodeType"]);
      toast.fire(
        "Success",
        "Producer Code Type has been deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate Producer Code Type",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteProdCodeType;
